import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL or Anon Key is missing. Please check your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
})

// Handle invalid refresh token errors by clearing the session
if (typeof window !== 'undefined') {
  // Check for invalid refresh tokens on initial load
  supabase.auth.getSession().then(({ error }) => {
    if (error && (error.message?.includes('Refresh Token') || error.message?.includes('Invalid'))) {
      console.warn('⚠️ Invalid refresh token detected, clearing session...')
      supabase.auth.signOut({ scope: 'local' }).catch(() => {
        // Ignore sign out errors
      })
    }
  }).catch((error: any) => {
    if (error?.message?.includes('Refresh Token') || error?.message?.includes('Invalid')) {
      console.warn('⚠️ Invalid refresh token detected, clearing session...')
      supabase.auth.signOut({ scope: 'local' }).catch(() => {
        // Ignore sign out errors
      })
    }
  })
}

// Auth helpers
export const auth = {
  signIn: async (email: string, password: string) => {
    // Clear any invalid sessions before signing in
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (session) {
        // Try to validate the session first
        const { error: validateError } = await supabase.auth.getUser()
        if (validateError?.message?.includes('Refresh Token') || validateError?.message?.includes('Invalid')) {
          // Clear invalid session
          await supabase.auth.signOut({ scope: 'local' })
        }
      }
    } catch (e) {
      // Ignore errors when checking session
    }

    const { data, error } = await supabase.auth.signInWithPassword({
      email: email.toLowerCase().trim(),
      password,
    })
    return { data, error }
  },

  signUp: async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signUp({
      email: email.toLowerCase().trim(),
      password,
    })
    return { data, error }
  },

  signOut: async () => {
    const { error } = await supabase.auth.signOut()
    return { error }
  },

  getSession: async () => {
    const { data, error } = await supabase.auth.getSession()
    return { data, error }
  },

  getUser: async () => {
    const { data, error } = await supabase.auth.getUser()
    return { data, error }
  },
}

